<!-- 用户协议 -->
<template>
    <div>
        <div class="container">
            <h3 style="text-align: center">用户服务协议</h3>
            <hr />
            <h3>[特别提醒]</h3>
            <p class="section"><b>1.请您（以下亦称“用户”）仔细阅读本协议全部条款，并确认您已完全了解本协议之规定。</b></p>
            <p class="section"><b>2.请您审慎阅读、充分理解各条款内容，并选择接受或不接收本协议。您的注册、登录、使用等行为将视为对本协议的接受，并视为您同意接受本协议各项条款的约束，本协议将构成您与“泉港智慧停车”之间直接有约束力的法律文件。</b></p>
            <p class="section"><b>3.请确认您依照中华人民共和国法律（为本协议之目的，含行政法规、部门规章、规范性文件，下同）及您所在地之法律、及您自愿或应当接受其管辖之法律（以下合称“法律”），有权签署并同意接受本协议的约束。</b></p>
            <h4>一、定义</h4>
            <p class="section">1.1本协议所称“泉港智慧停车”是泉港电子信息集团有限公司及其关联方与其主办的泉港智慧停车平台、泉港智慧停车微信公众号、泉港智慧停车微信小程序等传播平台之合称。</p>
            <p class="section">1.2本协议所称关联方是指控制某一方的、或被某一方所控制的、或与某一方共同受控制与同一实体的任何企业。控制是指直接或间接拥有该企业百分之五十（50%）以上的股权、投票权或管理权。</p>
            <h4>二、服务内容</h4>
            <p class="section">2.1“泉港智慧停车”主要是一家网络服务提供者，可针对不同渠道为用户提供综合的车辆布控服务，前述渠道包括但不限于：</p>
            <p class="section">2.1.1通过“泉港智慧停车”的服务；</p>
            <p class="section">2.1.2“泉港智慧停车”提供的可以使用的其他渠道。</p>
            <p class="section">
                2.2除免费服务外，“泉港智慧停车”可能提供部分收费服务。您可以通过付费方式购买收费服务，具体方式为：通过“泉港智慧停车”提供的第三方支付平台支付一定数额的货币，从而获得收费服务使用权限。<b
                    >对于收费服务，“泉港智慧停车”会在您使用之前给予明确的提示，只有根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，才能使用该等收费服务。支付行为的完成以银行或第三方支付平台生成“支付已完成”的确认通知为准。</b
                >
            </p>
            <p class="section">2.3您理解，“泉港智慧停车”仅提供与“泉港智慧停车”服务相关的技术服务，除此之外与相关网络服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用均由您自行负担。</p>
            <h4>三、服务的变更、中断或终止</h4>
            <p class="section"><b>3.1您理解网络服务具有特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他“泉港智慧停车”无法控制的情形），若发生中断或终止部分或全部服务的情况，“泉港智慧停车”将尽可能及时通过网页公告、系统通知、短信或其他合理方式进行通知。</b></p>
            <p class="section"><b>3.2您理解，“泉港智慧停车”会定期或不定期地对提供服务的“泉港智慧停车”平台（包括但不限于应用程序）进行检修或者维护，如因此类情况而造成服务中断，“泉港智慧停车”会尽可能事先进行通告。</b></p>
            <p class="section">3.3“泉港智慧停车”服务的更新</p>
            <p class="section">3.3.1为了改善用户体验、完善服务内容、保证服务的安全性、功能的一致性，“泉港智慧停车”将不断努力开发新的服务，并为用户不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、功能改变、版本升级等形式）。</p>
            <p class="section">3.3.2本软件新版本发布后，旧版本的软件可能无法使用。“泉港智慧停车”不保证旧版本软件及相应的客户服务继续可用，请您随时核实并下载最新版本。</p>
            <p class="section"><b>3.4您有权向“泉港智慧停车”申请注销您的账号，具体注销条件及程序请参照本协议中的附件《泉港智慧停车账号注销须知》。</b></p>
            <h4>四、商业活动</h4>
            <p class="section"><b>3.4您有权向“泉港智慧停车”申请注销您的账号，具体注销条件及程序请参照本协议中的附件《泉港智慧停车账号注销须知》。</b></p>
            <p class="section"><b>您了解并接受，“泉港智慧停车”可能通过泉港智慧停车APP、手机短信、网页或其他合法方式向用户发送商品促销或其他相关商业信息，包括但不限于通知信息、宣传信息、广告信息等。</b></p>
            <h4>五、账号的注册</h4>
            <p class="section">5.1您需要在“泉港智慧停车”注册一个账号，并按照“泉港智慧停车”的要求为该账号设置密码，才可以使用该账号登录并使用“泉港智慧停车”。您可依照“泉港智慧停车”的要求修改您的账号密码、昵称等信息。</p>
            <p class="section">5.2您注册账号时，应按照“泉港智慧停车”的提示及要求填写或提供资料、信息，并确保用户身份及信息的真实性、正确性及完整性；如果资料发生变化，您应及时更改。您同意并承诺：</p>
            <p class="section">5.2.1不故意冒用他人信息为您注册账号；</p>
            <p class="section">5.2.2不未经他人合法授权以他人名义注册账号；</p>
            <p class="section">5.2.3不适用色情、暴力或侮辱、诽谤他人等违反公序良俗的词语注册账号。</p>
            <p class="section"><b>如您违反前述规定，“泉港智慧停车”有权随时拒绝您使用该账号，或者限制您使用，或者注销该账号。</b></p>
            <p class="section">
                <b
                    >5.3您理解，“泉港智慧停车”账号的所有权归“泉港智慧停车”运营方所有，您完成申请注册流程后，获得相应账号的使用权。账号使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖账号或者以其他方式许可非初始申请注册人使用账号。非初始申请注册人不得通过承租、受让或者其他任何方式使用“泉港智慧停车”账号。</b
                >
            </p>
            <h4>六、账号的使用</h4>
            <p class="section">6.1您有责任妥善保管账号信息及密码，您同意在任何情况下不向他人透露账号及密码信息。当在您怀疑账号被他人使用时，应立即通知“泉港智慧停车”。您应当自行使用账号，并对任何利用您的账号及秘密所进行的活动负完全的责任。</p>
            <p class="section"><b>6.2您应了解，在账号和密码匹配时，“泉港智慧停车”无法对非法或未经您授权使用您账号及密码的行为作出甄别，因此，“泉港智慧停车”对任何使用您账号和密码登录并使用“泉港智慧停车”的行为不承担任何责任。您同意并承诺：</b></p>
            <p class="section"><b>6.2.1当您的账号或密码遭到未获授权的使用，或者发生其他任何安全问题时，您会立即有效通知“泉港智慧停车”，同时您理解“泉港智慧停车”对您的任何请求采取行动均需要合理时间，且“泉港智慧停车”应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大；</b></p>
            <p class="section"><b>6.2.2当您长时间不使用“泉港智慧停车”服务时，会将有关账号安全登出，以保证您的账号安全。</b></p>
            <p class="section">6.3账号因您主动泄露、遭他人攻击、诈骗等行为导致的损失计后果，您应通过司法、行政等救济途径向侵权行为人追偿。</p>
            <p class="section"><b>6.4“泉港智慧停车”有权根据自己的判定，在怀疑账号被不当使用时，拒绝或限制账号使用，或注销该账号，同时终止本协议。</b></p>
            <p class="section">6.5您同意，遵守法律及本协议规定，秉承善意使用“泉港智慧停车”，且保证：</p>
            <p class="section"><b>6.5.1不会利用“泉港智慧停车”进行非法活动、或进行侵犯他人权利或损害他人利益的活动；</b></p>
            <p class="section"><b>6.5.2不会以非法方式获取或利用“泉港智慧停车”其他用户的信息；</b></p>
            <p class="section"><b>6.5.3不会以技术方式攻击或破坏或改变“泉港智慧停车”的部分或全部、或干扰其运行；</b></p>
            <p class="section"><b>6.5.4不会以非法方式获取或使用“泉港智慧停车”的任何软件、代码或其他技术或商业信息；</b></p>
            <p class="section"><b>6.5.5不会对“泉港智慧停车”运行得任何程序进行反向工程、反向编译、反向汇编或改写；</b></p>
            <p class="section"><b>6.5.6不会未经许可使用“泉港智慧停车”的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由泉港电子信息集团有限公司（及关联方）或“泉港智慧停车 ”享有知识产权或权利的的信息或资料；</b></p>
            <p class="section"><b>6.5.7不会侵犯泉港电子信息集团有限公司（及关联方）或“泉港智慧停车”的商标权、著作权、专利权、其他知识产权或其他合法权利或权益。不会以任何方式贬损“泉港智慧停车”的商业声誉；</b></p>
            <p class="section">
                <b>6.5.8不会以商业目的使用“泉港智慧停车”，不对“泉港智慧停车”的任何部分或全部进行商业性质利用、复制、拷贝、出售、调查、广告，不将“泉港智慧停车”用于其他任何商业目的或商业性质的活动，但“泉港智慧停车”与您另行签订有协议或“泉港智慧停车”另行指定可供您使用的特定商业服务除外。</b>
            </p>
            <p class="section"><b>6.5.9不会利用“泉港智慧停车”进行其违反法律法规或他违背公序良俗的活动。 如您违反上述约定，“泉港智慧停车”可能将您违反法律或侵犯第三方权利或利益的记录报告给行政管理部门、司法机关。</b></p>
            <p class="section">6.6您应当确保您在“泉港智慧停车”所发布的信息不包含以下内容：</p>
            <p class="section"><b>6.6.1违反国家法律法规禁止性规定的；</b></p>
            <p class="section"><b>6.6.2政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</b></p>
            <p class="section"><b>6.6.3欺诈、虚假、不准确或存在误导性的；</b></p>
            <p class="section"><b>6.6.4侵犯他人知识产权或设计第三方商业秘密及其他专有权利的；</b></p>
            <p class="section"><b>6.6.5侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</b></p>
            <p class="section"><b>6.6.6存在可能破坏、篡改、删除、影响“泉港智慧停车”任何系统正常运行或未经授权秘密获取“泉港智慧停车”及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</b></p>
            <p class="section"><b>6.6.7其他违背社会公共利益或公共道德或依据相关“泉港智慧停车”规则的规定不适合在“泉港智慧停车”上发布的。</b></p>
            <h4>七、隐私保护</h4>
            <p class="section">7.1“泉港智慧停车”可能需要您填写能识别用户身份的个人信息以便可以在必要时您，或为您提供更好的使用体验。“个人信息”包括但不限于用户的姓名、性别、年龄、联系电话、地址、受教育情况、所处位置信息等。</p>
            <p class="section">7.2“泉港智慧停车”承诺，将按照法律法规规定及保证您安全稳定使用“泉港智慧停车”的方式获取、使用、保存、管理您在注册或使用“泉港智慧停车”过程中提供的个人信息，不以非法方式披露您的个人信息。</p>
            <p class="section">7.3您同意“泉港智慧停车”按照《泉港智慧停车隐私政策》对用户个人信息进行获取、使用、保存、管理和保护，具体条款见“泉港智慧停车”内展示的《泉港智慧停车隐私政策》。</p>
            <h4>八、知识产权</h4>
            <p class="section">
                8.1泉港电子信息集团有限公司对“泉港智慧停车”服务及“泉港智慧停车”所使用的软件所包含的受知识产权法或其他法律保护的资料享有相应的权利。“泉港智慧停车”的整体内容（包含但不仅限于设计图样以及其他图样、产品、服务名称等）版权归泉港电子信息集团有限公司所享有，任何人不得使用、复制或用作其他用途。
            </p>
            <p class="section"><b>8.2经由“泉港智慧停车”展示、传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律法规的保护，未经泉港电子信息集团有限公司书面授权许可，您不得自行或许可第三方进行复制、转载、修改、出租、售卖或衍生其他作品。</b></p>
            <p class="section">8.3“泉港智慧停车”对其专有内容、原创内容和其他通过授权取得的独占或者独家内容享有知识产权。未经“泉港智慧停车”书面许可，任何单位和个人不得私自转载、传播或者有其他侵犯“泉港智慧停车”知识产权的行为。否则，将承担法律责任。</p>
            <p class="section">
                8.4为了促进知识的分享和传播，您将在“泉港智慧停车”上发布的内容（包括但不仅限于留言、评论等），授予“泉港智慧停车”免费且不可撤销的非独家使用许可，“泉港智慧停车”有权将该内容用于“泉港智慧停车”各种形态的产品和服务上，包括但不限于“泉港智慧停车”以及“泉港智慧停车”发布的应用或其他互联网产品。您对“泉港智慧停车”的前述授权并不改变您发布内容的所有权及知识产权归属，也并不影响您行使对所发布内容的合法权利。
            </p>
            <h4>九、免责声明</h4>
            <p class="section"><b>9.1为方便您使用，“泉港智慧停车”可能会提供第三方互联网网站或资源链接。您应了解，除非另有声明，“泉港智慧停车”无法对第三方网站服务进行控制。您因下载、传播、使用或依赖上述网站或资源所产生的损失，由您自行承担责任。</b></p>
            <p class="section"><b>9.2“泉港智慧停车”尽可能保证其稳定运行。您应理解并同意，因法律、政策、技术、经济、管理的原因，“泉港智慧停车”不会因以下情形出现而对您承担责任：</b></p>
            <p class="section"><b>9.2.1“泉港智慧停车”无法使用、中断使用或无法适合用户的使用要求；</b></p>
            <p class="section"><b>9.2.2“泉港智慧停车”收到干扰，无法及时、安全、可靠运行，或出现任何错误；</b></p>
            <p class="section"><b>9.2.3经由“泉港智慧停车”取得的任何产品、服务（含收费服务）或其他材料不符合您的期望；</b></p>
            <p class="section"><b>9.2.4用户资料遭到未经授权的使用或修改。</b></p>
            <p class="section">
                <b
                    >9.3“泉港智慧停车”可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间。如您注销“泉港智慧停车”账号，或“泉港智慧停车”所提供的服务终止或取消，“泉港智慧停车”可以从服务器上永久地删除用户的数据，除法律又明确规定外，此种情形下，“泉港智慧停车”无法向用户返还或提供任何数据。</b
                >
            </p>
            <p class="section">
                9.4您应从“泉港智慧停车”官网或其他拥有“泉港智慧停车”授权的第三方获得安装程序。如果您从未经“泉港智慧停车”授权的第三方获得“泉港智慧停车”安装程序或名称相同的安装程序，“泉港智慧停车”无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。<br />
                9.5您在使用“泉港智慧停车”服务的过程中应遵守国家法律法规及政策规定，您使用“泉港智慧停车”服务而产生的行为后果由您自行承担。
            </p>
            <p class="section">
                9.6您通过“泉港智慧停车”发布的任何信息，及通过“泉港智慧停车”传递的任何观点不代表“泉港智慧停车”之立场，“泉港智慧停车”亦不对其完整性、真实性、准确性或可靠性负责。您对于可能会再“泉港智慧停车”上接触到的非法的、非道德的、错误的或存在其他失宜之处的信息，及被错误归类或是带有欺骗性的发布内容，应自行作出判断。在任何情况下，因前述非正当信息而导致的任何损失或伤害，应由相关行为主体承担全部责任。
            </p>
            <h4>十、违约责任</h4>
            <p class="section"><b>10.1如因“泉港智慧停车”违反有关法律、法规或本协议项下的任何条款而给您造成损失的，相应的损害赔偿由“泉港智慧停车”承担。</b></p>
            <p class="section"><b>10.2您同意保障和维护“泉港智慧停车”及其他用户的合法权益，如因您违反有关法律、法规或本协议项下的任何条款而给“泉港智慧停车”或任何其他第三方造成损失，您同意承担由此造成的损害赔偿责任。</b></p>
            <h4>十、违约责任</h4>
            <h4>十一、协议变更与终止</h4>
            <p class="section">11.1协议变更</p>
            <p class="section">11.1.1“泉港智慧停车”可根据法律、法规或政策变化，保护消费者权益，维护交易秩序的需要，不时修改本协议。</p>
            <p class="section">11.1.2本协议如果有变更，“泉港智慧停车”将尽可能提前在“泉港智慧停车”发布通知。但您应了解并同意，“泉港智慧停车”有可能未经事先通知，而修改或变更本协议的全部或部分内容，您也应随时关注本协议是否有修改或变更之情形。</p>
            <p class="section"><b>11.1.3如果本协议修改或变更，而您不能接受修改或变更后的内容，您可以停止使用“泉港智慧停车”。如果您继续使用“泉港智慧停车”，则表明您完全接受并愿意遵守修改或变更后的本协议。</b></p>
            <p class="section">11.2协议的中止与终止</p>
            <p class="section"><b>11.2.1本协议或本协议项下“泉港智慧停车”所提供的服务（含收费服务）可在下述情形下部分或全部中止或终止：</b></p>
            <p class="section">
                <b
                    >1）因法律规定，或“泉港智慧停车”服从行政命令或司法判令的要求；<br />
                    2）用户违反本协议；<br />
                    3）您盗用他人账号、发布违禁信息、骗取他人财物、销售、扰乱市场秩序、采取不正当手段谋利等行为的；<br />
                    4）在成功注销您的账号后；<br />
                    5）“泉港智慧停车”认为应予终止的其他情形。</b
                >
            </p>
            <p class="section"><b>11.2.2在一般情形下，“泉港智慧停车”会提前按照您提供的联系方式以电子邮件、短信或其他方式通知您，服务将中止或终止。您应了解并同意，在紧急情况下或不可抗力的情况下，“泉港智慧停车”可不经通知即中止或终止服务。</b></p>
            <p class="section">11.2.3在本协议或本协议项下“泉港智慧停车”提供的服务（含收费服务）中止时，“泉港智慧停车”有权拒绝用户登录“泉港智慧停车”。</p>
            <p class="section">11.2.4在本协议或本协议项下“泉港智慧停车”提供的服务（含收费服务）终止时，“泉港智慧停车”有权：</p>
            <p class="section">
                1）停止用户登录“泉港智慧停车”；<br />
                2）删除用户信息；<br />
                3）删除用户购买的内容
            </p>
            <p class="section">11.2.5您同意，不因本协议或本协议项下“泉港智慧停车”所提供的服务中止或终止，而要求“泉港智慧停车”向您作出赔偿或补偿或承担任何其他责任，但法律规定应由“泉港智慧停车”承担责任的除外。</p>
            <h4>十二、通知</h4>
            <p class="section">
                <b
                    >您在注册成为“泉港智慧停车”用户并接受“泉港智慧停车”服务时，应向“泉港智慧停车”提供真实有效的联系方式（包含但不限于联系电话等），对于联系方式发生变更的，您应及时更新有关信息，并保持可被联系的状态。“泉港智慧停车”将按照前述联系方式向您发送各类通知，此类通知的内容可能会对您的权利义务产生影响，请您务必及时关注。</b
                >
            </p>
            <h4>十三、法律适用</h4>
            <p class="section"><b>您在适用“泉港智慧停车”时，应遵守中华人民共和国法律、您所在地之法律及您资源或硬蛋接收其管辖之法律，本协议的解释及履行应按照中华人民共和国法律进行。</b></p>
            <h4>十四、争议解决</h4>
            <p class="section"><b>您和“泉港智慧停车”均同意，因本协议解释或执行引起的任何争议，双方应首先友好协商解决。协商不成时，则任一方均可将争议提交泉州仲裁委员会依据其届时有效的仲裁规则以仲裁方式解决。仲裁地点为泉州，仲裁语言为中文。仲裁裁决为终局的，对各方均有法律约束力。</b></p>
            <h4>十五、其他</h4>
            <p class="section">
                15.1“泉港智慧停车”可能不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议。<br />
                15.2本协议任一条款被视为废止、无效或不可执行，该条款应视为可分的且并不营销本协议其余条款的有效性及可执行性。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    components: {},

    computed: {},

    mounted() {},

    methods: {},
};
</script>
<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 40px;
}
.protocol-con {
    height: auto;
}
.title {
    text-align: center;
    font-size: 16px;
    margin: 0.5rem;
}
.section {
    text-indent: 2em;
    margin-bottom: 3px;
}
.textRgiht {
    text-align: right !important;
    color: #141414 !important;
}
h4 {
    color: #212121 !important;
    font-weight: bold;
}
</style>
